import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'utils/I18n';

const PromoButton = ({
  promotionApplied,
  isPromoCodeInputVisable,
  onToggleShowPromoCodeInput,
  handleRemovePromoCode
}) => (
  <>
    {promotionApplied ? (
      <button className="btn btn-link" onClick={handleRemovePromoCode}>
        {I18n.t(
          'strava.subscriptions.checkout.summary.organic.promo_code.cta.remove'
        )}
      </button>
    ) : (
      <button className="btn btn-link" onClick={onToggleShowPromoCodeInput}>
        {isPromoCodeInputVisable
          ? I18n.t(
              'strava.subscriptions.checkout.summary.organic.promo_code.cta.hide'
            )
          : I18n.t(
              'strava.subscriptions.checkout.summary.organic.promo_code.cta.enter'
            )}
      </button>
    )}
  </>
);

PromoButton.propTypes = {
  promotionApplied: PropTypes.bool.isRequired,
  isPromoCodeInputVisable: PropTypes.bool.isRequired,
  onToggleShowPromoCodeInput: PropTypes.func.isRequired,
  handleRemovePromoCode: PropTypes.func.isRequired
};

export default PromoButton;
